import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink, WorkflowLayout } from '@betterment/shared-components';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { usePurposeSelectionStep } from '../FlowConfig';

type Props = {};

export const AssignmentStep: React.FC<Props> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const { dependencies } = usePurposeSelectionStep('assignment');

  return (
    <WorkflowLayout pageTitle="">
      <WorkflowLayout.Header workflowTitle={null} onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))} />
      <WorkflowLayout.Content>
        <Text>Pick a target for how much and when you want your money. You can always change it later.</Text>
        <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
          <SambaAutoLink
            to={urlBuilder.appAddMajorPurchasePurpose.absolute()}
            variant="solidPrimary"
            css={{ width: 'fit-content' }}
          >
            Create new {dependencies.selection.purposeType}
          </SambaAutoLink>
        </Box>
      </WorkflowLayout.Content>
    </WorkflowLayout>
  );
};
